/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ method: NonNullable<unknown> }} Body_Assessment_Bodyfat_MethodInputs */

const en_us2_body_assessment_bodyfat_method = /** @type {(inputs: Body_Assessment_Bodyfat_MethodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Method: ${i?.method}`)
};

const pt_br2_body_assessment_bodyfat_method = /** @type {(inputs: Body_Assessment_Bodyfat_MethodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Método: ${i?.method}`)
};

const es_419_body_assessment_bodyfat_method = /** @type {(inputs: Body_Assessment_Bodyfat_MethodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Método: ${i?.method}`)
};

const pt_pt2_body_assessment_bodyfat_method = /** @type {(inputs: Body_Assessment_Bodyfat_MethodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Método: ${i?.method}`)
};

const fr_fr2_body_assessment_bodyfat_method = /** @type {(inputs: Body_Assessment_Bodyfat_MethodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Méthode : ${i?.method}`)
};

const de_de2_body_assessment_bodyfat_method = /** @type {(inputs: Body_Assessment_Bodyfat_MethodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Methode: ${i?.method}`)
};

const it_it2_body_assessment_bodyfat_method = /** @type {(inputs: Body_Assessment_Bodyfat_MethodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Metodo: ${i?.method}`)
};

/**
* | output |
* | --- |
* | "Method: {method}" |
*
* @param {Body_Assessment_Bodyfat_MethodInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_bodyfat_method = /** @type {((inputs: Body_Assessment_Bodyfat_MethodInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Bodyfat_MethodInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_bodyfat_method(inputs)
	if (locale === "es-419") return es_419_body_assessment_bodyfat_method(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_bodyfat_method(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_bodyfat_method(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_bodyfat_method(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_bodyfat_method(inputs)
	return en_us2_body_assessment_bodyfat_method(inputs)
});
export { body_assessment_bodyfat_method as "body-assessment.bodyfat_method" }